import _extends from "@babel/runtime-corejs3/helpers/extends";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import React, { Children } from 'react';
import { useToken } from '@rexlabs/styling';
import Box from '@rexlabs/box';
import Tag from './basic';

/**
 * This component is used to group related tags together, and to limit the amount of them that are visible at any one time, dealing with the overflow automatically.
 */
export function TagGroup(_ref) {
  var children = _ref.children,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 5 : _ref$max,
      ellipsis = _ref.ellipsis,
      props = _objectWithoutProperties(_ref, ["children", "max", "ellipsis"]);

  var c = children;
  var more = 0;
  var token = useToken();
  var count = Children.count(children);

  if (max && count > max) {
    var _context;

    c = _sliceInstanceProperty(_context = Children.toArray(children)).call(_context, 0, max - 1);
    more = count - (max - 1);
  }

  return /*#__PURE__*/React.createElement(Box, _extends({
    flexDirection: "row",
    flexWrap: ellipsis ? 'nowrap' : 'wrap',
    spacing: token('spacing.xs')
  }, props), c, more > 0 && /*#__PURE__*/React.createElement(Tag, null, "+ ", more, " more"));
}
export default TagGroup;